import { Glue42Core } from "@glue42/core";

import manager from "./Manager";
import {Glue42Office} from "../../../glue4office";
import {AttachmentImpl} from "./AttachmentImplementation";

export class EmailImpl implements Glue42Office.Outlook.Email {
    public attachments: Glue42Office.Outlook.Attachment[];
    public bcc: Glue42Office.Outlook.T42Contact | Glue42Office.Outlook.T42Contact[];
    public body: string;
    public bodyHtml: string;
    public cc: Glue42Office.Outlook.T42Contact | Glue42Office.Outlook.T42Contact[];
    public date: Date;
    public ids: Glue42Office.Outlook.T42Id[];
    public sender: Glue42Office.Outlook.T42Contact;
    public subject: string;
    public to: Glue42Office.Outlook.T42Contact | Glue42Office.Outlook.T42Contact[];
    public entityType: number;

    constructor(email: Glue42Office.Outlook.T42Email, agm: Glue42Core.AGM.API) {
        if (email.attachments && email.attachments.length > 0) {
            this.attachments = [];
            email.attachments.forEach((att: Glue42Office.Outlook.T42Attachment) => {
                this.attachments.push(new AttachmentImpl(att, agm, this));
            });
        }
        this.bcc = email.bcc;
        this.body = email.body;
        this.bodyHtml = email.bodyHtml;
        this.cc = email.cc;
        this.date = email.date;
        this.ids = email.ids;
        this.sender = email.sender;
        this.subject = email.subject;
        this.to = email.to;
        this.entityType = email.entityType;
    }

    public show(): Promise<Glue42Office.Outlook.T42Id[]> {
        return manager.showItemMethod(this.ids, "showEmail");
    }

    public saveToFile(): Promise<string> {
        return manager.saveItemMethod(this.ids, "saveEmail");
    }

    public getAsMsg(): Promise<string> {
        return manager.getItemAsMsg(this.ids);
    }

    public track(conversationId?: Glue42Office.Outlook.T42Id): Promise<{ emailIds: Glue42Office.Outlook.T42Id[], conversationIds: Glue42Office.Outlook.T42Id[] }> {
        return manager.handleTrackingEmails("track", this.ids, conversationId);
    }

    public untrack(): Promise<{ emailIds: Glue42Office.Outlook.T42Id[], conversationIds: Glue42Office.Outlook.T42Id[] }> {
        return manager.handleTrackingEmails("untrack", this.ids);
    }
}
